import { $isElementNode, LexicalEditor, LexicalNode } from 'lexical';

export function exportChildrenToDOM(
  parentNode: LexicalNode,
  container: HTMLElement,
  editor: LexicalEditor,
): void {
  if (!$isElementNode(parentNode)) {
    return;
  }

  const children = parentNode.getChildren();
  for (const child of children) {
    const childDOM = exportNodeToDOM(child, editor);
    if (childDOM) {
      container.appendChild(childDOM);
    }
  }
}

export function exportNodeToDOM(node: LexicalNode, editor: LexicalEditor): Node | null {
  const exportOutput = node.exportDOM(editor);
  if (!exportOutput?.element) {
    return null;
  }

  let element = exportOutput.element;

  if ($isElementNode(node)) {
    const children = node.getChildren();
    for (const child of children) {
      const childDOM = exportNodeToDOM(child, editor);
      if (childDOM) {
        element.appendChild(childDOM);
      }
    }
  }

  if (exportOutput.after) {
    const newElement = exportOutput.after(element);
    if (newElement) {
      element = newElement;
    }
  }

  return element;
}
